import { BaseApi as Base } from '@micromag/data';

class AccountApi extends Base {
    get() {
        return this.requestGet(this.route('account'));
    }

    create(data) {
        return this.requestPost(this.route('register'), data);
    }

    complete(data) {
        return this.requestPost(this.route('register.complete'), data);
    }

    update(data) {
        return this.requestPost(this.route('account.update'), data);
    }

    delete(id) {
        return this.requestDelete(this.route('account.delete'), { id });
    }
}

export default AccountApi;
